<script lang="ts" setup>
	import {onMounted} from 'vue';
	import {useClients} from '@/scripts/composables/use-clients.ts';

	const {initProcesses, processes} = useProcesses();
	const {initClients, clients} = useClients();

	onMounted(async () => {
		await initProcesses();
		await initClients();
	});
</script>

<template>
	<FormElementGrid :columns="1">
		<FormElementText
			:label="$t('ui.common.name')"
			:placeholder="$t('ui.common.name')"
			name="name"
			required
		/>
		<FormElementSelect
			:label="$tChoice('domains.tenant.process.title', 1)"
			:options="
				processes?.map((p) => ({
					label: p.name,
					value: p.versionUuid,
				})) ?? []
			"
			:placeholder="$t('domains.tenant.project.create.select_process')"
			name="processVersionUuid"
		/>
		<FormElementSelect
			:label="$tChoice('domains.tenant.client.title', 1)"
			:options="
				clients?.map((c) => ({label: c.name, value: c.uuid})) ?? []
			"
			:placeholder="$t('domains.tenant.project.create.select_client')"
			name="clientUuid"
		/>
	</FormElementGrid>
</template>
